import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import {
  PatchScheduledMessageResponseTO,
  ScheduledMessageReschedulePayload,
} from 'models/automation/ScheduledMessages';
import API from 'services/API';
import { SCHEDULED_MESSAGES_BASE_QUERY_KEY } from './scheduledMessagesQuery';

type RescheduleScheduledMessageMutationArgs =
  ScheduledMessageReschedulePayload & {
    scheduledMessageUid: string;
  };

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    PatchScheduledMessageResponseTO,
    BaseErrorResponse,
    RescheduleScheduledMessageMutationArgs
  >,
  'mutationFn' | 'mutationKey'
>;

const rescheduleScheduledMessage = ({
  scheduledMessageUid,
  ...payload
}: RescheduleScheduledMessageMutationArgs) => {
  return API.post<PatchScheduledMessageResponseTO, BaseErrorResponse>(
    `/api/internal/triggers/scheduled-messages/reschedule/${scheduledMessageUid}`,
    null,
    { params: payload },
  );
};

const useRescheduleScheduledMessageMutation = ({
  onSuccess,
  ...options
}: ReactQueryMutationOptions = {}) => {
  const queryClient = useQueryClient();

  return useAppMutation({
    mutationFn: rescheduleScheduledMessage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries([SCHEDULED_MESSAGES_BASE_QUERY_KEY]);
      return onSuccess?.(...args);
    },
    ...options,
  });
};

export default useRescheduleScheduledMessageMutation;
